import { CompletedProgrammeWorkout } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseMutationOptions, UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export type CompleteProgrammeWorkoutParams = {
  programmeId: string
  programmeWorkoutId: string
  maxHeartRate: number
  calories: number
  averageHeartRate: number
  hustleScore: number
}

export const useCompleteProgrammeWorkout = (
  options?: Omit<UseMutationOptions<CompletedProgrammeWorkout, Error, CompleteProgrammeWorkoutParams>, 'mutationFn'>,
): UseMutationResult<CompletedProgrammeWorkout, Error, CompleteProgrammeWorkoutParams> => {
  const queryClient = useQueryClient()

  return useMutation<CompletedProgrammeWorkout, Error, CompleteProgrammeWorkoutParams>(
    (params) => coreService.completeProgrammeWorkout(params),
    {
      onSuccess: (_, { programmeId }) => {
        queryClient.invalidateQueries(queryKeys.completedWorkouts())
        queryClient.invalidateQueries(queryKeys.completedProgrammeWorkouts(programmeId))
        queryClient.invalidateQueries(queryKeys.programmeWorkouts(programmeId))
        queryClient.invalidateQueries(queryKeys.hustlerProgramme(programmeId))
        queryClient.invalidateQueries(queryKeys.myStartedProgrammes())
        queryClient.invalidateQueries({ queryKey: queryKeys.myStartedProgrammesFromLibraryPrefix() })
        queryClient.invalidateQueries(queryKeys.suggestedSeries())
      },
      ...options,
    },
  )
}
